import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface GetCrmRawContactPayload {
  apiKey: string;
  contactId: string;
}

export interface GetCrmRawContactResponse {
  success: boolean;
  partnerSystem: string;
  contactId: string;
  contact: Record<string, unknown> | null;
  validationData: Record<string, unknown>;
}

async function getCrmRawContact(
  payload: GetCrmRawContactPayload,
  auth: Authentication
): Promise<GetCrmRawContactResponse> {
  try {
    return await HttpClient.get(
      `/integrations/contacts/raw?apiKey=${encodeURIComponent(payload.apiKey)}&contactId=${encodeURIComponent(payload.contactId)}`,
      auth.token,
      { 'x-api-key': payload.apiKey },
    );
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : 'Unknown error';
    throw new GetCrmRawContactFailure(errorMessage, 'raw-contact-error');
  }
}

class GetCrmRawContactFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCrmRawContact;
